import { UNIT_TYPES } from 'constants/unitTypes';

export const fertilityProductSubstanceTypeNames = [
  'LIME',
  'NITROGEN',
  'PHOSPHORUS',
  'POTASSIUM'
].reduce((result, key) => { result[key] = `${key.toLowerCase()}`; return result; }, {});

export const applicationProductSubstanceSets = [
  'LPK',
  'NITROGEN' // might not need nitrogen refractor later
].reduce((result, key) => { result[key] = `${key.toLowerCase()}`; return result; }, {});

export const fertilityProductSubstanceSets = [
  'LPK',
  'NITROGEN'
].reduce((result, key) => { result[key] = `${key.toLowerCase()}`; return result; }, {});

export const applicationProductFormats = [
  'DRY',
  'WET'
].reduce((result, key) => { result[key] = `${key.toLowerCase()}`; return result; }, {});

export const fertilityProductFormats = [
  'DRY',
  'WET'
].reduce((result, key) => { result[key] = `${key.toLowerCase()}`; return result; }, {});

export const fertilityProductFormatUnits = {
  [fertilityProductFormats.DRY]: UNIT_TYPES.pound_acre,
  [fertilityProductFormats.WET]: UNIT_TYPES.gal_ac
};

export const substanceThreshholds = {
  [fertilityProductSubstanceTypeNames.LIME]: { min: 20, max: 100 }
};

export const densities = {
  WATER: 8.34
};

export const MIN_HYBRID_PRODUCT_SEARCH_LENGTH = 3;

export const PRECEON_BRAND_UUID = '8ef72bd0-6074-480d-8e43-76d11f8ed815';
